import styled from "styled-components";

export const StyledReportPage = styled.div`
    margin: 5rem 2rem 0rem 2rem;
    background-color: white;
`;